module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Share</h2>\n</div>\n\n<div class=\"modal-body\">\n  <p class=\"center\">{{ shareBarConfig.message }}</p>\n  <share-bar config=\"shareBarConfig\"></share-bar>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/shareLink/shareLink.html
// module id = 885
// module chunks = 1